import { useQuery } from '@tanstack/react-query'
import {
  getProcurementActionablePurchaseRequests,
  getProcurementDashboardCounts,
  getProcurementMyPurchaseRequests,
  getProcurementPurchaseOrders,
  getProcurementPurchaseRequests,
} from 'api'
import { Flex } from 'styling/GlobalStyles'
import styled from 'styled-components'

const DashboardRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 26rem;
  gap: 24px;
  margin-top: 24px;
  width: 100%;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`
import { DashboardCount } from './Components/DashboardCount/DashboardCount'
import { MyPendingApprovals } from './Components/MyPendingApprovals'
import { OpenPurchaseOrder } from './Components/OpenPurchaseOrder'

export const Dashboard = () => {
  const { data } = useQuery({
    queryKey: ['procurement-dashboard-counts'],
    queryFn: () => getProcurementDashboardCounts(),
  })
  const actionablePurchaseRequestsQuery = useQuery({
    queryKey: ['procurement-actionable-purchase-requests'],
    queryFn: () =>
      getProcurementActionablePurchaseRequests({
        page: 1,
        limit: 10,
      }),
  })
  const purchuseRequestsQuery = useQuery({
    queryKey: ['procurement-purchase-requests'],
    queryFn: () =>
      getProcurementPurchaseRequests({
        page: 1,
        limit: 5,
      }),
  })

  const { data: purchaseOrders } = useQuery({
    queryKey: ['procurement-purchase-orders'],
    queryFn: () =>
      getProcurementPurchaseOrders({
        page: 1,
        limit: 5,
      }),
  })

  const myRequestsQuery = useQuery({
    queryKey: ['procurement-my-purchase-requests'],
    queryFn: () =>
      getProcurementMyPurchaseRequests({
        page: 1,
        limit: 5,
      }),
  })

  return (
    <>
      <DashboardCount counts={data} />
      <DashboardRow>
        <MyPendingApprovals
          purchaseRequestsQuery={purchuseRequestsQuery}
          actionablePurchaseRequestsQuery={actionablePurchaseRequestsQuery}
          myRequestsQuery={myRequestsQuery}
        />
        <OpenPurchaseOrder purchaseOrders={purchaseOrders?.data || []} />
      </DashboardRow>
    </>
  )
}
